import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
});

export const settings = {
  copyableOptions: {
    relationsToCopy: ['externalReferences'],
  },
  saveHooks: {
    after: [saveHasManyRelationships('externalReferences')],
  },
};

export default class DivisionModel extends Model.extend(Validations) {
  @attr('string') name;
  @attr('string') shortName;
  @attr('string') text;

  // Relations
  @hasMany('external-reference', { async: true, inverse: 'division' })
  externalReferences;
  @belongsTo('link', { async: true, inverse: null }) link;
  @belongsTo('organization', { async: true, inverse: null }) organization;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter, setter and computed properties
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
